import { Directive, ElementRef, OnDestroy, Renderer2 } from '@angular/core';
import { Subscription } from 'rxjs';
import { filter } from 'rxjs/operators';
import { LoadingIndicatorService } from '../../e-met/services/loading-indicator.service';

@Directive({
    selector: '[appRotateRefreshOnHttp]',
})
export class RotateRefreshOnHttpDirective implements OnDestroy {
    sub: Subscription;
    constructor(
        private renderer: Renderer2,
        private el: ElementRef,
        private loadingIndicator: LoadingIndicatorService
    ) {
        this.sub = this.loadingIndicator.loadingStatus
            .pipe(filter((ev) => ev.reqId === 'refresh'))
            .subscribe((reqData) => {
                reqData.loading && reqData.customId == this.el.nativeElement.id
                    ? this.enableSpinner()
                    : this.disableSpinner();
            });
    }
    ngOnDestroy(): void {
        this.sub?.unsubscribe();
    }

    enableSpinner() {
        this.renderer.addClass(this.el.nativeElement, 'rotate');
    }

    disableSpinner() {
        this.renderer.removeClass(this.el.nativeElement, 'rotate');
    }
}
